import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-student-completed-survey',
  templateUrl: './student-completed-survey.component.html',
  styleUrl: './student-completed-survey.component.scss'
})
export class StudentCompletedSurveyComponent implements OnInit {
  constructor(private router: Router) { }
  ngOnInit() {
    setTimeout(() => {
      this.router.navigate(['']);
    }, 3000);
  }
}
